var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41667 2.49992C5.08515 2.49992 4.7673 2.63171 4.53288 2.86613C4.29846 3.10055 4.16667 3.4184 4.16667 3.74992V13.6148C4.5537 13.4312 4.98011 13.3333 5.41667 13.3333H15.8333V2.49992H5.41667ZM4.16667 16.2499C4.16667 16.5814 4.29846 16.8993 4.53288 17.1337C4.7673 17.3681 5.08515 17.4999 5.41667 17.4999H15.8333V14.9999H5.41667C5.08515 14.9999 4.7673 15.1317 4.53288 15.3661C4.29846 15.6005 4.16667 15.9184 4.16667 16.2499ZM17.5 17.4999C17.5 17.9419 17.3243 18.3657 17.0117 18.6783C16.6992 18.9909 16.2754 19.1666 15.8333 19.1666H5.41667C4.64312 19.1666 3.90147 18.8591 3.35449 18.3121C2.80751 17.7651 2.5 17.0235 2.5 16.2499V3.74992C2.5 2.97637 2.80751 2.23473 3.35449 1.68774C3.90147 1.14076 4.64312 0.833252 5.41667 0.833252H15.8333C16.2754 0.833252 16.6992 1.00897 17.0117 1.32153C17.3243 1.63409 17.5 2.05789 17.5 2.49992V17.4999Z",
    fill: "#6366F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.98755f9c5ec32b769a6d4456fe653fc5.svg";
export { ForwardRef as ReactComponent };